// Référentiels prédéfinis pour les fiches de réalisations.
// Listes communes et réutilisables ; « Autre » permet toujours une saisie libre.

export const FORMATS = [
  "Court-métrage",
  "Long-métrage",
  "Documentaire",
  "Film institutionnel",
  "Film de sensibilisation",
  "Publicité",
  "Clip musical",
  "Captation événementielle",
  "Interview",
  "Reportage",
  "Web-série",
  "Bande-annonce",
];

export const GENRES = [
  "Comédie",
  "Drame",
  "Action",
  "Thriller",
  "Horreur",
  "Science-fiction",
  "Fantastique",
  "Romance",
  "Aventure",
  "Policier",
  "Animation",
];

export const THEMATIQUES = [
  "Jeunesse",
  "Éducation",
  "Sensibilisation",
  "Social",
  "Environnement",
  "Culture",
  "Sport",
  "Formation",
  "Citoyenneté",
];

export const ROLES = [
  "Écriture / Scénario",
  "Réalisation",
  "Coréalisation",
  "Production",
  "Coproduction",
  "Direction de la photographie",
  "Cadrage",
  "Tournage",
  "Prise de son",
  "Pilotage drone",
  "Montage",
  "Étalonnage",
  "Postproduction",
  "Effets visuels / VFX",
  "Photographie",
  "Direction artistique",
  "Accompagnement audiovisuel",
];

// Partenaires prédéfinis (en plus de ceux créés dans l'admin).
export const PARTENAIRES_DEFAUT = [
  "Ville de Mitry-Mory",
  "SIJ — Service Information Jeunesse",
  "BV Studio",
  "Karams Studio",
];

// Années : de l'année en cours à 1990 (décroissant).
export const YEARS = (() => {
  const y = new Date().getFullYear();
  return Array.from({ length: y - 1989 }, (_, i) => String(y - i));
})();
